import script from "./TabsBootstrap.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsBootstrap.vue?vue&type=script&setup=true&lang=js"

import "./TabsBootstrap.vue?vue&type=style&index=0&id=baf0058c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-baf0058c"]])

export default __exports__